export const CATEGORY_CREATED_SUCCESS_MESSAGE = 'Category created';
export const CATEGORY_DELETED_SUCCESS_MESSAGE = 'Category deleted';
export const CATEGORY_DELETED_ERROR_MESSAGE = "You're not authorized to delete categories";

export const SERVICE_CREATED_SUCCESS_MESSAGE = 'Service created';
export const SERVICE_UPDATED_SUCCESS_MESSAGE = 'Service updated';
export const SERVICE_DELETED_SUCCESS_MESSAGE = 'Service deleted';
export const SERVICE_CREATED_ERROR_MESSAGE = "Couldn't create the service";
export const SERVICE_UPDATED_ERROR_MESSAGE = "Couldn't update the service";

export const SERVICE_QUERY_KEY = 'services';
